import { TutorialDefinition } from './tutorialDefinitions';

/**
 * General game tutorials covering basic UI and navigation
 */

export const UI_BASICS_TUTORIAL: TutorialDefinition = {
  key: 'ui-basics',
  title: 'User Interface Basics',
  description: 'Learn about the main navigation and interface elements',
  category: 'general',
  priority: 'critical',
  estimatedMinutes: 1,
  icon: '📱',
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Heroes of the Grid!',
      content: 'This brief tutorial will help you understand the game interface. You can skip any tutorial at any time using the Skip button.',
      position: 'center',
      type: 'info'
    },
    {
      id: 'navigation',
      title: 'Main Navigation',
      content: 'Use the navigation menu to access different parts of the game: World Map, Characters, Crafting, and more.',
      position: 'center',
      type: 'info'
    },
    {
      id: 'help-menu',
      title: 'Help & Tutorials',
      content: 'You can always replay tutorials or access help from the Help menu. Look for the Help button in the navigation bar.',
      position: 'center',
      type: 'info'
    },
    {
      id: 'complete',
      title: 'Tutorial Complete!',
      content: 'Great! You now know the basics. Explore the game and discover more features. More detailed tutorials will appear when you access specific game systems.',
      position: 'center',
      type: 'info'
    }
  ]
};

export const generalTutorials = [UI_BASICS_TUTORIAL];
